<template>
  <div :style="wrapStyle" class="material-wrap">
    <div class="material" :class="item.class" :style="outerStyle(item.style)">
      <div
        :style="innerStyle(item.style)"
        class="material-inner"
        @click.stop.prevent="selectMaterial($event, item, index)"
      >
        <span>{{ item.type === "text" ? item.text : "" }}</span>
        <div class="edit-box" @click.stop="edit(item)" v-if="editVisible(item)">
          <img v-if="item.type === 'text'" class="icon" src="./images/text_icon.png" />
          <img v-else class="icon" src="./images/image_icon.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { styleFormat, xValue, yValue } from "@/utils/invitationUtil";
import * as Api from "@/api/bridge";
import { mapSrc } from "@/utils/amap";

export default {
  name: "material",
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    page: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      scale: state => state.config.scale
    }),
    wrapStyle() {
      const { scale, item } = this;
      const { isFull, style = {} } = item;
      return {
        transform: `scale(${isFull ? scale : 1})`,
        zIndex: style.zIndex
      };
    },
    is_tpl() {
      return this.$route.query.is_tpl;
    }
  },
  methods: {
    src(style) {
      const { width, height } = style;
      const { lat, lng } = this;
      return mapSrc({
        width: xValue(width),
        height: yValue(height),
        lat,
        lng
      });
    },
    editVisible(item) {
      const { initial = {} } = item;
      const { type } = this.page;
      // 第一页特殊处理
      if (type === "first") {
        if (
          item.type == "text" &&
          !["date", "datetime"].includes(initial.text_type)
        ) {
          return false;
        }
      }
      // 最后一页特殊处理
      if (
        type === "last" &&
        initial.text_type &&
        initial.text_type !== "address" &&
        initial.text_type !== "text"
      ) {
        return false;
      }

      return item.static != 1 && !this.is_tpl;
    },
    edit(item) {
      const { type, initial = {} } = { ...item };
      item.page_id = String(this.page.id);
      item.id = String(item.id);
      if (item.imageType === "map") {
        return Api.editInfo(item);
      }
      if (type === "text") {
        if (initial.text_type === "text") {
          return Api.editText(item);
        } else {
          return Api.editInfo(item);
        }
      }
      return Api.editImage(item);
    },
    selectMaterial(event, item, index) {
      const { imageType } = item;
      if (imageType === "reply") {
        this.$toast("这封请柬好像还没有发出去哦");
      }
      this.$emit("click", event, item, index);
    },
    outerStyle(style) {
      const { item } = this;
      const { imageType } = item;
      const pointerEvents = !imageType && item.static == 1 ? "none" : "auto";

      return [
        style,
        {
          maskSize: "",
          maskRepeat: "",
          maskPosition: "",
          maskImage: "",
          borderColor: "",
          borderStyle: "",
          borderWidth: "",
          borderRadius: "",
          transform: "",
          backgroundImage: "",
          backgroundColor: "",
          backgroundRepeat: "",
          backgroundSize: "",
          boxShadow: "",
          pointerEvents
        }
      ];
    },
    innerStyle(style = {}) {
      const { imageType } = this.item;
      return {
        maskSize: style.maskSize,
        maskRepeat: style.maskRepeat,
        maskPosition: style.maskPosition,
        maskImage: style.maskImage,
        borderColor: style.borderColor,
        borderStyle: style.borderStyle,
        borderWidth: `${style.borderWidth}px`,
        borderRadius: `${style.borderRadius}%`,
        boxShadow: style.boxShadow,
        backgroundImage:
          imageType === "map"
            ? `url(${this.src(style)})`
            : style.backgroundImage,
        backgroundSize: style.backgroundSize,
        transform: styleFormat({
          ...style
        }),
        backgroundColor: style.backgroundColor,
        backgroundRepeat: style.backgroundRepeat
      };
    }
  }
};
</script>
<style lang="less" scoped>
.material-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.material {
  position: absolute;
  pointer-events: auto;
}
.material-inner {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  mask-size: 100% 100%;
  mask-position: center center;
  white-space: pre-line;
  overflow: hidden;
}
.edit-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 0.66rem;
    height: 0.73rem;
    transform: translateZ(1000px);
  }
}
</style>
